<template>
  
  <v-layout row class="mt-4 mx-2 pa-4" justify-center>
    <v-flex xs12 md6 lg4 justify-center>
      <h2 class="grey--text text-center">¡Bienvenido!</h2>
      <h2 class="grey--text text-center">
        {{
          $store.getters.autor.nombres + " " + $store.getters.autor.apellidos
        }}
      </h2>
      <br />
      <p v-if="usuario && usuario.autor.avisoGeneral">
        {{ usuario.autor.avisoGeneral }}
      </p>

      <img :src="require('../assets/aviso.jpeg')" alt width="100%" /> 
      <!-- <v-img max-width="450" src="img/aviso.jpeg" alt="apa" class="mb-4" /> -->
    </v-flex>

    <div></div>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      nombre: "",
      usuario: null,
      mostrarAviso: false
    };
  },
  mounted() {
    axios
      .get("/miapa/miusuario")
      .then(response => {
        console.log(response.data);
        this.usuario = response.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    test() {
      //
    },
    datosSocio() {
      // axios
      //   .get("/usuario/socio/misdatos")
      //   .then(response => {
      //     console.log(response);
      //     if (response.data && response.data.socio) {
      //       this.nombre =
      //         response.data.socio.nombres + " " + response.data.socio.apellidos;
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    }
  },
  components: {}
};
</script>
